var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-txt-m"},[_c('div',{staticClass:"row-txt-header"},[_vm._v(_vm._s(_vm.kpi ? _vm.kpi.KpiName : ''))]),_vm._v(" "),_c('performanceitem',{attrs:{"overallByWave":_vm.getOverallByWave,"kpi":_vm.kpi}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }